import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'

export const HeaderEvolucao = ({ paciente, ativo }) => {
  const nmPaciente = paciente?.nmPaciente || '---'

  const dtExibicao = ativo?.[4] || ativo?.[3]

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography variant="h6">Evolução de Enfermagem</Typography>
        <Typography variant="body2" color="textSecondary">
          Paciente: {nmPaciente}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        {dtExibicao && (
          <Typography variant="body2" color="textSecondary">
            {dayjs(dtExibicao).format('DD/MM/YYYY HH:mm')}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default HeaderEvolucao
